import { render, staticRenderFns } from "./GameDialog.vue?vue&type=template&id=1276797a&scoped=true"
import script from "./GameDialog.vue?vue&type=script&lang=ts"
export * from "./GameDialog.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GameDialog.vue?vue&type=style&index=0&id=1276797a&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1276797a",
  "89d33e8a"
  
)

export default component.exports